import { FC } from 'react';
import { clsx } from 'clsx';

import { IHeaderGroupRowTableSchedule } from '../models/IHeaderGroupRowTableSchedule';

import styles from './styles.module.scss';

export const HeaderGroupRowTableSchedule: FC<IHeaderGroupRowTableSchedule> = ({
  isScrolled,
}) => {
  return (
    <div
      className={clsx(styles['table-schedule-row'], {
        [styles['table-schedule-row_scrolled']]: isScrolled,
      })}
    >
      <div className={styles['table-schedule-cell']}>
        <div className={styles['table-schedule__time-interval']}>
          Дата и время
        </div>
      </div>
      <div className={styles['table-schedule-cell']}>
        <div className={styles['table-schedule__discipl-type']}>
          Тип занятия
        </div>
      </div>
      <div className={styles['table-schedule-cell']}>Дисциплина</div>
      <div className={styles['table-schedule-cell']}>Аудитория и здание</div>
      <div className={styles['table-schedule-cell']}>
        <div className={styles['table-schedule__teacher']}>Преподаватель</div>
      </div>
      <div className={styles['table-schedule-cell']}>Кафедра</div>
    </div>
  );
};
